/* tslint:disable */

/* eslint-disable */

/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import type { AxiosInstance, AxiosPromise, RawAxiosRequestConfig } from "axios";
import globalAxios from "axios";

// @ts-ignore
import {
  BASE_PATH,
  BaseAPI,
  COLLECTION_FORMATS,
  RequestArgs,
  RequiredError,
  operationServerMap,
} from "../base";
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  createRequestFunction,
  serializeDataIfNeeded,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  toPathString,
} from "../common";
import type { Configuration } from "../configuration";
// @ts-ignore
import { JoinOrLeaveClubsRequestDto } from "../models";
// @ts-ignore
import { QueryFiltersDto } from "../models";
// @ts-ignore
import { RequestReplayRequestDto } from "../models";
// @ts-ignore
import { UpdateNicknameRequestDto } from "../models";

/**
 * CommandControllerApi - axios parameter creator
 * @export
 */
export const CommandControllerApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {string} domain
     * @param {JoinOrLeaveClubsRequestDto} joinOrLeaveClubsRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountsLeaveClubs: async (
      domain: string,
      joinOrLeaveClubsRequestDto: JoinOrLeaveClubsRequestDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'domain' is not null or undefined
      assertParamExists("accountsLeaveClubs", "domain", domain);
      // verify required parameter 'joinOrLeaveClubsRequestDto' is not null or undefined
      assertParamExists(
        "accountsLeaveClubs",
        "joinOrLeaveClubsRequestDto",
        joinOrLeaveClubsRequestDto
      );
      const localVarPath = `/api/v2/command/accounts-leave-clubs/{domain}`.replace(
        `{${"domain"}}`,
        encodeURIComponent(String(domain))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        joinOrLeaveClubsRequestDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} domain
     * @param {JoinOrLeaveClubsRequestDto} joinOrLeaveClubsRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    joinAccountsToClubs: async (
      domain: string,
      joinOrLeaveClubsRequestDto: JoinOrLeaveClubsRequestDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'domain' is not null or undefined
      assertParamExists("joinAccountsToClubs", "domain", domain);
      // verify required parameter 'joinOrLeaveClubsRequestDto' is not null or undefined
      assertParamExists(
        "joinAccountsToClubs",
        "joinOrLeaveClubsRequestDto",
        joinOrLeaveClubsRequestDto
      );
      const localVarPath = `/api/v2/command/join-accounts-to-clubs/{domain}`.replace(
        `{${"domain"}}`,
        encodeURIComponent(String(domain))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        joinOrLeaveClubsRequestDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} domain
     * @param {string} gsId
     * @param {QueryFiltersDto} queryFiltersDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    migrateAccounts: async (
      domain: string,
      gsId: string,
      queryFiltersDto: QueryFiltersDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'domain' is not null or undefined
      assertParamExists("migrateAccounts", "domain", domain);
      // verify required parameter 'gsId' is not null or undefined
      assertParamExists("migrateAccounts", "gsId", gsId);
      // verify required parameter 'queryFiltersDto' is not null or undefined
      assertParamExists("migrateAccounts", "queryFiltersDto", queryFiltersDto);
      const localVarPath = `/api/v2/command/migrate-accounts/{domain}/{gs-id}`
        .replace(`{${"domain"}}`, encodeURIComponent(String(domain)))
        .replace(`{${"gs-id"}}`, encodeURIComponent(String(gsId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        queryFiltersDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} domain
     * @param {string} tesId
     * @param {QueryFiltersDto} queryFiltersDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    registerAccounts: async (
      domain: string,
      tesId: string,
      queryFiltersDto: QueryFiltersDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'domain' is not null or undefined
      assertParamExists("registerAccounts", "domain", domain);
      // verify required parameter 'tesId' is not null or undefined
      assertParamExists("registerAccounts", "tesId", tesId);
      // verify required parameter 'queryFiltersDto' is not null or undefined
      assertParamExists("registerAccounts", "queryFiltersDto", queryFiltersDto);
      const localVarPath = `/api/v2/command/register-accounts/{domain}/{tes-id}`
        .replace(`{${"domain"}}`, encodeURIComponent(String(domain)))
        .replace(`{${"tes-id"}}`, encodeURIComponent(String(tesId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        queryFiltersDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} domain
     * @param {string} sessionId
     * @param {RequestReplayRequestDto} requestReplayRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    requestReplay: async (
      domain: string,
      sessionId: string,
      requestReplayRequestDto: RequestReplayRequestDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'domain' is not null or undefined
      assertParamExists("requestReplay", "domain", domain);
      // verify required parameter 'sessionId' is not null or undefined
      assertParamExists("requestReplay", "sessionId", sessionId);
      // verify required parameter 'requestReplayRequestDto' is not null or undefined
      assertParamExists("requestReplay", "requestReplayRequestDto", requestReplayRequestDto);
      const localVarPath = `/api/v2/command/request-replay/{domain}/{session-id}`
        .replace(`{${"domain"}}`, encodeURIComponent(String(domain)))
        .replace(`{${"session-id"}}`, encodeURIComponent(String(sessionId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        requestReplayRequestDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} domain
     * @param {string} tesId
     * @param {QueryFiltersDto} queryFiltersDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    runAccounts: async (
      domain: string,
      tesId: string,
      queryFiltersDto: QueryFiltersDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'domain' is not null or undefined
      assertParamExists("runAccounts", "domain", domain);
      // verify required parameter 'tesId' is not null or undefined
      assertParamExists("runAccounts", "tesId", tesId);
      // verify required parameter 'queryFiltersDto' is not null or undefined
      assertParamExists("runAccounts", "queryFiltersDto", queryFiltersDto);
      const localVarPath = `/api/v2/command/run-accounts/{domain}/{tes-id}`
        .replace(`{${"domain"}}`, encodeURIComponent(String(domain)))
        .replace(`{${"tes-id"}}`, encodeURIComponent(String(tesId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        queryFiltersDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} domain
     * @param {QueryFiltersDto} queryFiltersDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    stopAccounts: async (
      domain: string,
      queryFiltersDto: QueryFiltersDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'domain' is not null or undefined
      assertParamExists("stopAccounts", "domain", domain);
      // verify required parameter 'queryFiltersDto' is not null or undefined
      assertParamExists("stopAccounts", "queryFiltersDto", queryFiltersDto);
      const localVarPath = `/api/v2/command/stop-accounts/{domain}`.replace(
        `{${"domain"}}`,
        encodeURIComponent(String(domain))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        queryFiltersDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} domain
     * @param {string} gsId
     * @param {SwitchGsModeModeEnum} mode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    switchGsMode: async (
      domain: string,
      gsId: string,
      mode: SwitchGsModeModeEnum,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'domain' is not null or undefined
      assertParamExists("switchGsMode", "domain", domain);
      // verify required parameter 'gsId' is not null or undefined
      assertParamExists("switchGsMode", "gsId", gsId);
      // verify required parameter 'mode' is not null or undefined
      assertParamExists("switchGsMode", "mode", mode);
      const localVarPath = `/api/v2/command/switch-gs-mode/{domain}/{gs-id}/{mode}`
        .replace(`{${"domain"}}`, encodeURIComponent(String(domain)))
        .replace(`{${"gs-id"}}`, encodeURIComponent(String(gsId)))
        .replace(`{${"mode"}}`, encodeURIComponent(String(mode)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} domain
     * @param {string} tesId
     * @param {SwitchTesModeModeEnum} mode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    switchTesMode: async (
      domain: string,
      tesId: string,
      mode: SwitchTesModeModeEnum,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'domain' is not null or undefined
      assertParamExists("switchTesMode", "domain", domain);
      // verify required parameter 'tesId' is not null or undefined
      assertParamExists("switchTesMode", "tesId", tesId);
      // verify required parameter 'mode' is not null or undefined
      assertParamExists("switchTesMode", "mode", mode);
      const localVarPath = `/api/v2/command/switch-tes-mode/{domain}/{tes-id}/{mode}`
        .replace(`{${"domain"}}`, encodeURIComponent(String(domain)))
        .replace(`{${"tes-id"}}`, encodeURIComponent(String(tesId)))
        .replace(`{${"mode"}}`, encodeURIComponent(String(mode)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} domain
     * @param {string} sessionId
     * @param {File} [avatar]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateAccountAvatar: async (
      domain: string,
      sessionId: string,
      avatar?: File,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'domain' is not null or undefined
      assertParamExists("updateAccountAvatar", "domain", domain);
      // verify required parameter 'sessionId' is not null or undefined
      assertParamExists("updateAccountAvatar", "sessionId", sessionId);
      const localVarPath = `/api/v2/command/update-account-avatar/{domain}/{session-id}`
        .replace(`{${"domain"}}`, encodeURIComponent(String(domain)))
        .replace(`{${"session-id"}}`, encodeURIComponent(String(sessionId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      const localVarFormParams = new ((configuration && configuration.formDataCtor) ||
        FormData)();

      if (avatar !== undefined) {
        localVarFormParams.append("avatar", avatar as any);
      }

      localVarHeaderParameter["Content-Type"] = "multipart/form-data";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = localVarFormParams;

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} domain
     * @param {string} sessionId
     * @param {UpdateNicknameRequestDto} updateNicknameRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateAccountNickname: async (
      domain: string,
      sessionId: string,
      updateNicknameRequestDto: UpdateNicknameRequestDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'domain' is not null or undefined
      assertParamExists("updateAccountNickname", "domain", domain);
      // verify required parameter 'sessionId' is not null or undefined
      assertParamExists("updateAccountNickname", "sessionId", sessionId);
      // verify required parameter 'updateNicknameRequestDto' is not null or undefined
      assertParamExists(
        "updateAccountNickname",
        "updateNicknameRequestDto",
        updateNicknameRequestDto
      );
      const localVarPath = `/api/v2/command/update-account-nickname/{domain}/{session-id}`
        .replace(`{${"domain"}}`, encodeURIComponent(String(domain)))
        .replace(`{${"session-id"}}`, encodeURIComponent(String(sessionId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        updateNicknameRequestDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} domain
     * @param {QueryFiltersDto} queryFiltersDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateAccountsAvatars: async (
      domain: string,
      queryFiltersDto: QueryFiltersDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'domain' is not null or undefined
      assertParamExists("updateAccountsAvatars", "domain", domain);
      // verify required parameter 'queryFiltersDto' is not null or undefined
      assertParamExists("updateAccountsAvatars", "queryFiltersDto", queryFiltersDto);
      const localVarPath = `/api/v2/command/update-accounts-avatars/{domain}`.replace(
        `{${"domain"}}`,
        encodeURIComponent(String(domain))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        queryFiltersDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} domain
     * @param {QueryFiltersDto} queryFiltersDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateAccountsNicknames: async (
      domain: string,
      queryFiltersDto: QueryFiltersDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'domain' is not null or undefined
      assertParamExists("updateAccountsNicknames", "domain", domain);
      // verify required parameter 'queryFiltersDto' is not null or undefined
      assertParamExists("updateAccountsNicknames", "queryFiltersDto", queryFiltersDto);
      const localVarPath = `/api/v2/command/update-accounts-nicknames/{domain}`.replace(
        `{${"domain"}}`,
        encodeURIComponent(String(domain))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        queryFiltersDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * CommandControllerApi - functional programming interface
 * @export
 */
export const CommandControllerApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = CommandControllerApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {string} domain
     * @param {JoinOrLeaveClubsRequestDto} joinOrLeaveClubsRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async accountsLeaveClubs(
      domain: string,
      joinOrLeaveClubsRequestDto: JoinOrLeaveClubsRequestDto,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.accountsLeaveClubs(
        domain,
        joinOrLeaveClubsRequestDto,
        options
      );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap["CommandControllerApi.accountsLeaveClubs"]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {string} domain
     * @param {JoinOrLeaveClubsRequestDto} joinOrLeaveClubsRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async joinAccountsToClubs(
      domain: string,
      joinOrLeaveClubsRequestDto: JoinOrLeaveClubsRequestDto,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.joinAccountsToClubs(
        domain,
        joinOrLeaveClubsRequestDto,
        options
      );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap["CommandControllerApi.joinAccountsToClubs"]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {string} domain
     * @param {string} gsId
     * @param {QueryFiltersDto} queryFiltersDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async migrateAccounts(
      domain: string,
      gsId: string,
      queryFiltersDto: QueryFiltersDto,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.migrateAccounts(
        domain,
        gsId,
        queryFiltersDto,
        options
      );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap["CommandControllerApi.migrateAccounts"]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {string} domain
     * @param {string} tesId
     * @param {QueryFiltersDto} queryFiltersDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async registerAccounts(
      domain: string,
      tesId: string,
      queryFiltersDto: QueryFiltersDto,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.registerAccounts(
        domain,
        tesId,
        queryFiltersDto,
        options
      );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap["CommandControllerApi.registerAccounts"]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {string} domain
     * @param {string} sessionId
     * @param {RequestReplayRequestDto} requestReplayRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async requestReplay(
      domain: string,
      sessionId: string,
      requestReplayRequestDto: RequestReplayRequestDto,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.requestReplay(
        domain,
        sessionId,
        requestReplayRequestDto,
        options
      );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap["CommandControllerApi.requestReplay"]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {string} domain
     * @param {string} tesId
     * @param {QueryFiltersDto} queryFiltersDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async runAccounts(
      domain: string,
      tesId: string,
      queryFiltersDto: QueryFiltersDto,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.runAccounts(
        domain,
        tesId,
        queryFiltersDto,
        options
      );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap["CommandControllerApi.runAccounts"]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {string} domain
     * @param {QueryFiltersDto} queryFiltersDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async stopAccounts(
      domain: string,
      queryFiltersDto: QueryFiltersDto,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.stopAccounts(
        domain,
        queryFiltersDto,
        options
      );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap["CommandControllerApi.stopAccounts"]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {string} domain
     * @param {string} gsId
     * @param {SwitchGsModeModeEnum} mode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async switchGsMode(
      domain: string,
      gsId: string,
      mode: SwitchGsModeModeEnum,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.switchGsMode(
        domain,
        gsId,
        mode,
        options
      );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap["CommandControllerApi.switchGsMode"]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {string} domain
     * @param {string} tesId
     * @param {SwitchTesModeModeEnum} mode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async switchTesMode(
      domain: string,
      tesId: string,
      mode: SwitchTesModeModeEnum,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.switchTesMode(
        domain,
        tesId,
        mode,
        options
      );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap["CommandControllerApi.switchTesMode"]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {string} domain
     * @param {string} sessionId
     * @param {File} [avatar]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateAccountAvatar(
      domain: string,
      sessionId: string,
      avatar?: File,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.updateAccountAvatar(
        domain,
        sessionId,
        avatar,
        options
      );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap["CommandControllerApi.updateAccountAvatar"]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {string} domain
     * @param {string} sessionId
     * @param {UpdateNicknameRequestDto} updateNicknameRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateAccountNickname(
      domain: string,
      sessionId: string,
      updateNicknameRequestDto: UpdateNicknameRequestDto,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.updateAccountNickname(
        domain,
        sessionId,
        updateNicknameRequestDto,
        options
      );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap["CommandControllerApi.updateAccountNickname"]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {string} domain
     * @param {QueryFiltersDto} queryFiltersDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateAccountsAvatars(
      domain: string,
      queryFiltersDto: QueryFiltersDto,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.updateAccountsAvatars(
        domain,
        queryFiltersDto,
        options
      );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap["CommandControllerApi.updateAccountsAvatars"]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {string} domain
     * @param {QueryFiltersDto} queryFiltersDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateAccountsNicknames(
      domain: string,
      queryFiltersDto: QueryFiltersDto,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.updateAccountsNicknames(
        domain,
        queryFiltersDto,
        options
      );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap["CommandControllerApi.updateAccountsNicknames"]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, operationBasePath || basePath);
    },
  };
};

/**
 * CommandControllerApi - factory interface
 * @export
 */
export const CommandControllerApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = CommandControllerApiFp(configuration);
  return {
    /**
     *
     * @param {string} domain
     * @param {JoinOrLeaveClubsRequestDto} joinOrLeaveClubsRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountsLeaveClubs(
      domain: string,
      joinOrLeaveClubsRequestDto: JoinOrLeaveClubsRequestDto,
      options?: any
    ): AxiosPromise<void> {
      return localVarFp
        .accountsLeaveClubs(domain, joinOrLeaveClubsRequestDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} domain
     * @param {JoinOrLeaveClubsRequestDto} joinOrLeaveClubsRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    joinAccountsToClubs(
      domain: string,
      joinOrLeaveClubsRequestDto: JoinOrLeaveClubsRequestDto,
      options?: any
    ): AxiosPromise<void> {
      return localVarFp
        .joinAccountsToClubs(domain, joinOrLeaveClubsRequestDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} domain
     * @param {string} gsId
     * @param {QueryFiltersDto} queryFiltersDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    migrateAccounts(
      domain: string,
      gsId: string,
      queryFiltersDto: QueryFiltersDto,
      options?: any
    ): AxiosPromise<void> {
      return localVarFp
        .migrateAccounts(domain, gsId, queryFiltersDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} domain
     * @param {string} tesId
     * @param {QueryFiltersDto} queryFiltersDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    registerAccounts(
      domain: string,
      tesId: string,
      queryFiltersDto: QueryFiltersDto,
      options?: any
    ): AxiosPromise<void> {
      return localVarFp
        .registerAccounts(domain, tesId, queryFiltersDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} domain
     * @param {string} sessionId
     * @param {RequestReplayRequestDto} requestReplayRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    requestReplay(
      domain: string,
      sessionId: string,
      requestReplayRequestDto: RequestReplayRequestDto,
      options?: any
    ): AxiosPromise<void> {
      return localVarFp
        .requestReplay(domain, sessionId, requestReplayRequestDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} domain
     * @param {string} tesId
     * @param {QueryFiltersDto} queryFiltersDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    runAccounts(
      domain: string,
      tesId: string,
      queryFiltersDto: QueryFiltersDto,
      options?: any
    ): AxiosPromise<void> {
      return localVarFp
        .runAccounts(domain, tesId, queryFiltersDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} domain
     * @param {QueryFiltersDto} queryFiltersDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    stopAccounts(
      domain: string,
      queryFiltersDto: QueryFiltersDto,
      options?: any
    ): AxiosPromise<void> {
      return localVarFp
        .stopAccounts(domain, queryFiltersDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} domain
     * @param {string} gsId
     * @param {SwitchGsModeModeEnum} mode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    switchGsMode(
      domain: string,
      gsId: string,
      mode: SwitchGsModeModeEnum,
      options?: any
    ): AxiosPromise<void> {
      return localVarFp
        .switchGsMode(domain, gsId, mode, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} domain
     * @param {string} tesId
     * @param {SwitchTesModeModeEnum} mode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    switchTesMode(
      domain: string,
      tesId: string,
      mode: SwitchTesModeModeEnum,
      options?: any
    ): AxiosPromise<void> {
      return localVarFp
        .switchTesMode(domain, tesId, mode, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} domain
     * @param {string} sessionId
     * @param {File} [avatar]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateAccountAvatar(
      domain: string,
      sessionId: string,
      avatar?: File,
      options?: any
    ): AxiosPromise<void> {
      return localVarFp
        .updateAccountAvatar(domain, sessionId, avatar, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} domain
     * @param {string} sessionId
     * @param {UpdateNicknameRequestDto} updateNicknameRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateAccountNickname(
      domain: string,
      sessionId: string,
      updateNicknameRequestDto: UpdateNicknameRequestDto,
      options?: any
    ): AxiosPromise<void> {
      return localVarFp
        .updateAccountNickname(domain, sessionId, updateNicknameRequestDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} domain
     * @param {QueryFiltersDto} queryFiltersDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateAccountsAvatars(
      domain: string,
      queryFiltersDto: QueryFiltersDto,
      options?: any
    ): AxiosPromise<void> {
      return localVarFp
        .updateAccountsAvatars(domain, queryFiltersDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} domain
     * @param {QueryFiltersDto} queryFiltersDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateAccountsNicknames(
      domain: string,
      queryFiltersDto: QueryFiltersDto,
      options?: any
    ): AxiosPromise<void> {
      return localVarFp
        .updateAccountsNicknames(domain, queryFiltersDto, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * CommandControllerApi - object-oriented interface
 * @export
 * @class CommandControllerApi
 * @extends {BaseAPI}
 */
export class CommandControllerApi extends BaseAPI {
  /**
   *
   * @param {string} domain
   * @param {JoinOrLeaveClubsRequestDto} joinOrLeaveClubsRequestDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CommandControllerApi
   */
  public accountsLeaveClubs(
    domain: string,
    joinOrLeaveClubsRequestDto: JoinOrLeaveClubsRequestDto,
    options?: RawAxiosRequestConfig
  ) {
    return CommandControllerApiFp(this.configuration)
      .accountsLeaveClubs(domain, joinOrLeaveClubsRequestDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} domain
   * @param {JoinOrLeaveClubsRequestDto} joinOrLeaveClubsRequestDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CommandControllerApi
   */
  public joinAccountsToClubs(
    domain: string,
    joinOrLeaveClubsRequestDto: JoinOrLeaveClubsRequestDto,
    options?: RawAxiosRequestConfig
  ) {
    return CommandControllerApiFp(this.configuration)
      .joinAccountsToClubs(domain, joinOrLeaveClubsRequestDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} domain
   * @param {string} gsId
   * @param {QueryFiltersDto} queryFiltersDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CommandControllerApi
   */
  public migrateAccounts(
    domain: string,
    gsId: string,
    queryFiltersDto: QueryFiltersDto,
    options?: RawAxiosRequestConfig
  ) {
    return CommandControllerApiFp(this.configuration)
      .migrateAccounts(domain, gsId, queryFiltersDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} domain
   * @param {string} tesId
   * @param {QueryFiltersDto} queryFiltersDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CommandControllerApi
   */
  public registerAccounts(
    domain: string,
    tesId: string,
    queryFiltersDto: QueryFiltersDto,
    options?: RawAxiosRequestConfig
  ) {
    return CommandControllerApiFp(this.configuration)
      .registerAccounts(domain, tesId, queryFiltersDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} domain
   * @param {string} sessionId
   * @param {RequestReplayRequestDto} requestReplayRequestDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CommandControllerApi
   */
  public requestReplay(
    domain: string,
    sessionId: string,
    requestReplayRequestDto: RequestReplayRequestDto,
    options?: RawAxiosRequestConfig
  ) {
    return CommandControllerApiFp(this.configuration)
      .requestReplay(domain, sessionId, requestReplayRequestDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} domain
   * @param {string} tesId
   * @param {QueryFiltersDto} queryFiltersDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CommandControllerApi
   */
  public runAccounts(
    domain: string,
    tesId: string,
    queryFiltersDto: QueryFiltersDto,
    options?: RawAxiosRequestConfig
  ) {
    return CommandControllerApiFp(this.configuration)
      .runAccounts(domain, tesId, queryFiltersDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} domain
   * @param {QueryFiltersDto} queryFiltersDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CommandControllerApi
   */
  public stopAccounts(
    domain: string,
    queryFiltersDto: QueryFiltersDto,
    options?: RawAxiosRequestConfig
  ) {
    return CommandControllerApiFp(this.configuration)
      .stopAccounts(domain, queryFiltersDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} domain
   * @param {string} gsId
   * @param {SwitchGsModeModeEnum} mode
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CommandControllerApi
   */
  public switchGsMode(
    domain: string,
    gsId: string,
    mode: SwitchGsModeModeEnum,
    options?: RawAxiosRequestConfig
  ) {
    return CommandControllerApiFp(this.configuration)
      .switchGsMode(domain, gsId, mode, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} domain
   * @param {string} tesId
   * @param {SwitchTesModeModeEnum} mode
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CommandControllerApi
   */
  public switchTesMode(
    domain: string,
    tesId: string,
    mode: SwitchTesModeModeEnum,
    options?: RawAxiosRequestConfig
  ) {
    return CommandControllerApiFp(this.configuration)
      .switchTesMode(domain, tesId, mode, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} domain
   * @param {string} sessionId
   * @param {File} [avatar]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CommandControllerApi
   */
  public updateAccountAvatar(
    domain: string,
    sessionId: string,
    avatar?: File,
    options?: RawAxiosRequestConfig
  ) {
    return CommandControllerApiFp(this.configuration)
      .updateAccountAvatar(domain, sessionId, avatar, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} domain
   * @param {string} sessionId
   * @param {UpdateNicknameRequestDto} updateNicknameRequestDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CommandControllerApi
   */
  public updateAccountNickname(
    domain: string,
    sessionId: string,
    updateNicknameRequestDto: UpdateNicknameRequestDto,
    options?: RawAxiosRequestConfig
  ) {
    return CommandControllerApiFp(this.configuration)
      .updateAccountNickname(domain, sessionId, updateNicknameRequestDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} domain
   * @param {QueryFiltersDto} queryFiltersDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CommandControllerApi
   */
  public updateAccountsAvatars(
    domain: string,
    queryFiltersDto: QueryFiltersDto,
    options?: RawAxiosRequestConfig
  ) {
    return CommandControllerApiFp(this.configuration)
      .updateAccountsAvatars(domain, queryFiltersDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} domain
   * @param {QueryFiltersDto} queryFiltersDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CommandControllerApi
   */
  public updateAccountsNicknames(
    domain: string,
    queryFiltersDto: QueryFiltersDto,
    options?: RawAxiosRequestConfig
  ) {
    return CommandControllerApiFp(this.configuration)
      .updateAccountsNicknames(domain, queryFiltersDto, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * @export
 */
export const SwitchGsModeModeEnum = {
  Production: "PRODUCTION",
  Test: "TEST",
  Unavailable: "UNAVAILABLE",
  Service: "SERVICE",
} as const;
export type SwitchGsModeModeEnum =
  (typeof SwitchGsModeModeEnum)[keyof typeof SwitchGsModeModeEnum];
/**
 * @export
 */
export const SwitchTesModeModeEnum = {
  Production: "PRODUCTION",
  Test: "TEST",
  Unavailable: "UNAVAILABLE",
  Service: "SERVICE",
} as const;
export type SwitchTesModeModeEnum =
  (typeof SwitchTesModeModeEnum)[keyof typeof SwitchTesModeModeEnum];
